import React from 'react';
import { Grid, Cell } from 'react-md';

const ReservationLoader = () => {
  const loadingStyle = {
    background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
    backgroundSize: '200% 100%',
    animation: 'loading 1.5s infinite',
    borderRadius: '4px',
  };

  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes loading {
        0% { background-position: 200% 0; }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div style={{
      padding: 0,
      margin: 0,
      minHeight: '10vh',
     
    }}>
      

      <div style={{ position: 'relative', marginBottom: '15px' }}>
  <div
    style={{
      ...loadingStyle,
      width: '100%',
      height: '56px',
      borderRadius: '20px'
    }}
  />
  <span
    style={{
      position: 'absolute',
      top: 0,
      left: 5,
      width: '100%',
      height: '56px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      color: '#666',
      pointerEvents: 'none'
    }}
  >
    Loading available dates...
  </span>
</div>
    </div>
  );
};

export default ReservationLoader;